import React from 'react';

import moment from 'moment'

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {AutocompleteInput, DateInput, ReferenceInput, required, Title} from 'react-admin';
import {downloadFile, IFrameHtmlReport, ReportForm} from '../../components';
import env from '../../env';

class StudentAttendance extends React.Component {
    state = {
        openHtmlReport: false,
        htmlReportUrl: '',
        studentId: '',
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
    };

    getReportUrl = (type) => {
        const token = localStorage.getItem('token');
        return `${env.baseURL}/reports/student_attendance` +
            `?type=` + type +
            `&pStudentId=` + this.state.studentId +
            `&pFromDate=` + this.state.fromDate +
            `&pToDate=` + this.state.toDate +
            `&token=` + token;
    }

    getReportUrlToDownload = (type) => {
        return `${env.baseURL}/reports/student_attendance` +
            `?type=` + type +
            `&pStudentId=` + this.state.studentId +
            `&pFromDate=` + this.state.fromDate +
            `&pToDate=` + this.state.toDate
    }

    htmlReport = () => {
        const htmlReportUrl = this.getReportUrl('HTML')
        this.setState({openHtmlReport: true, htmlReportUrl })
    }

    pdfReport = () => {
        downloadFile(this.getReportUrlToDownload('PDF'), 'bao_cao_diem_danh_hoc_sinh.pdf')
    }

    excelReport = () => {
        downloadFile(this.getReportUrlToDownload('XLS'), 'bao_cao_diem_danh_hoc_sinh.xlsx')
    }

    validate = (values) => {
        const errors = {};

        // Validate
        if (values.fromDate && values.toDate && (values.fromDate > values.toDate) ){
            errors.toDate = 'To date must be greater than From date'
        }
        values.studentId = this.state.studentId;

        this.setState({
            fromDate: values.fromDate,
            toDate: values.toDate
        })

        return errors;
    }

    onClazzChanged(e, value) {
        this.setState({
            studentId: ''
        })
    }

    onStudentChanged(e, value) {
        this.setState({
            studentId: value
        })
    }

    render() {
        return (
            <Card>
                <Title title="Báo cáo điểm danh học sinh" />
                <CardContent>
                    <ReportForm params={this.state}
                                validate={this.validate}
                                htmlReport={this.htmlReport}
                                pdfReport={this.pdfReport}
                                excelReport={this.excelReport}
                    >
                        <Grid container spacing={8}>
                            <Grid item xs={12} sm={6} >
                                <ReferenceInput source="studentId"
                                                reference="customers"
                                                validate={required()}
                                                filter={{studentOnly: true}}
                                                sort={{ field: 'name', order: 'ASC' }}
                                                onChange={(e, value) => this.onStudentChanged(e, value)}
                                                perPage={50}>
                                    <AutocompleteInput optionText="name" />
                                </ReferenceInput>
                            </Grid>

                            <Grid item xs={12} sm={6} >
                                <DateInput source="fromDate" validate={required()} {...this.props} />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <DateInput source="toDate" validate={required()} {...this.props} />
                            </Grid>
                        </Grid>
                    </ReportForm>

                    {/* The iframe to show HTML report */}
                    {
                        this.state.openHtmlReport &&
                        <IFrameHtmlReport src={this.state.htmlReportUrl} />
                    }
                </CardContent>
            </Card>
        )
    }
}

export default StudentAttendance

